<template>
<div class="smsup">
    <div id="g-bd" class="g-bd-2">
        <div class="m-info-new">
            <p class="middle">验证手机号：{{mobile}}<span v-if="fromluo" class="change" @click="changeMobile">切换手机号</span></p>
            <div class="note2">
                <div class="tips middle">为了确认您的身份，请用该手机发送短信：</div>
                <div class="cnt-box f-cf">
                    <div class="middle2">
                        <p class="cnt1">编辑短信：<span class="u-light">{{receiveCode1}}</span></p>
                        <p class="line"></p>
                        <p class="cnt2">发送至：<span class="u-light">{{receiveCode3}}</span></p>
                    </div>
                </div>
            </div>
            <p class="upsms-note3 middle">系统不会进行短信回复，短信费用由运营商收取。</p>
        </div>
        <div class="m-btn middle">
            <div class="u-btn"><div class="u-upload-note"><a class="u-note-2" @click="gosms" :href="smscnt">前往发送短信</a></div></div>
        </div>
        <p class="upsms-note3 middle">如果“前往发送短信”操作失败，请手动发送短信</p>
        <div class="middle">
            <div class="m-btn m-btn-2">
                <urs-button enableTip="我已发送短信，登录" @click="checkSmsUp"  ref="submitBtn"></urs-button>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import bowser from "bowser"
import reqProxy from '../util/request'
import util from '../util/util'
import code from '../util/codemapper'

const TIME = 3000;

// @NOTE 两个接口返回码文案基本一致，合并一个
// @NOTE 除非有code冲突，否则保持和原来一致的文案
let vfmbsmsCodeTemp = {
  '431': "请求错误，请您稍后再试",
  '412': "验证码错误次数过多，请明天再试",
  '413': "当日尝试次数过多，请明天再试",
  '443': "系统未收到短信或短信内容错误",
  '430': "此次登录不需要进行密保验证",
  '415': "请获取短信验证码",
  '409':'系统未收到短信或短信内容错误'
}

let vfsmsCodeTemp = {
  '431': "请求错误，请您稍后再试",
  '410': "超过IP限制，请稍候再试",
  '412': "验证码错误次数过多，请明天再试",
  '413': "当日尝试次数过多，请明天再试",
  '443':"系统未收到短信或短信内容错误",
  '453': "账号未关联手机号",
  '454': "账号关联手机未验证",
  '430': "此次登录不需要进行密保验证",
  '415': "请获取短信验证码",
  '409':'系统未收到短信或短信内容错误'
}
let vfmbsmsCode = Object.assign({},code,vfmbsmsCodeTemp);
let vfsmsCode = Object.assign({},code,vfsmsCodeTemp);

export default {
  props: {
    options:Object
  },
  data () {
    return {
      fromluo:this.options.fromluo,
      smsCount: 29,
      showUp: '',
      receiveCode:this.options.receiveCode,
      mobile:this.options.mobile,
      receiveCode1:this.options.receiveCode1,
      receiveCode2:this.options.receiveCode2,
      receiveCode3:this.options.receiveCode3,
      smscnt:bowser.ios ? this.options.smscnt : 'javascript:void(0)'
    }
  },
  mounted () {
    this.ajaxList = [];
    window.Loading.loading = false;
  },
  beforeDestroy () {
      if (this.sto){
          this.sto = clearTimeout(this.sto);
      }
      this.ajaxList.forEach(item => {
          item && item.abort();
      });
      this.ajaxList = [];
  },
  methods: {
    // 点击确认提交
    checkSmsUp () {
        if (this.fromluo){
          this.checkSmsUpLuo();
        }else{
          this.checkSmsUpMb();
        }
    },
    checkSmsUpMb (){
      let data = {
        un: this.options.un,
        mb: this.mobile,
        n: 1
      }
      this.$refs.submitBtn.state = 'loading';
      this.sto = setTimeout(()=>{
        let ajax = reqProxy({
          url: '/vfsms',
          method: 'POST',
          contentType: 'application/x-www-form-urlencoded',
          data: data,
          success: (data)=>{
            // 校验成功
            // 回到登录且自动帮助用户登录
            this.$refs.submitBtn.state = 'enable'
            this.$emit('changeToLogin',{autoLogin:1})
          },
          error:(data)=>{
            this.$refs.submitBtn.state = 'enable'
            // 特殊错误-返回登录界面
            if (data.ret == '415'){
              this.changeMobile(vfmbsmsCode[data.ret],'verifymb')
              return;
            }
            if(data.ret == '430' || data.ret === '434' ||data.ret === '435' || data.ret === '436' || data.ret === '437' || data.ret === '413' || data.ret === '412'){
              this.$emit('changeToLogin',{errMsg:vfsmsCode[data.ret]})
              return;
            }
            // 通用错误
            window.showError(vfsmsCode[data.ret]);
          }
        })
        ajax && this.ajaxList.push(ajax);
      },TIME)
    },
    checkSmsUpLuo () {
      this.$refs.submitBtn.state = 'loading';
      let data = {
        un: this.options.un,
        mb: this.mobile,
        n:1
      }
      this.sto = setTimeout(()=>{
        let ajax = reqProxy({
            url: '/vfmbsms',
            method: 'POST',
            contentType: 'application/x-www-form-urlencoded',
            data: data,
            success:(data)=>{
                // 校验成功
                // 回到登录且自动帮助用户登录
                this.$refs.submitBtn.state = 'enable'
                this.$emit('changeToLogin',{autoLogin:1})
            },
            error:(data)=>{
                this.$refs.submitBtn.state = 'enable';
                if (this.ignore){
                    return;
                }
                // 特殊错误-手机号格式错误
                if(data.ret === '401' && data.dt === '09'){
                  window.showError('手机号格式错误');
                  return;
                }
                if(data.ret === '401' && data.dt === '10'){
                  window.showError('账号格式错误');
                  return;
                }
                // 不会返回415
                // if (data.ret == '415'){
                //   this.changeMobile(vfmbsmsCode[data.ret],'verifyluo')
                //   return;
                // }
                // 特殊错误-返回登录界面
                if(data.ret == '430' || data.ret === '434' ||data.ret === '435' || data.ret === '436' || data.ret === '437' ){
                this.$emit('changeToLogin',{errMsg:vfmbsmsCode[data.ret]})
                return;
                }
                // 通用错误
                window.showError(vfmbsmsCode[data.ret]);
            }
            })
        ajax && this.ajaxList.push(ajax);
      },TIME)
    },
    changeMobile (txt,target) {
        this.ignore = true;
        // 默认切换到裸账号
        target = target ||'verifyluo';
        this.$emit('changeModule',{module:target,newUp:true,receiveCode:this.receiveCode,errMsg:txt})
    },
    gosms(){
      if ( !bowser.ios ) {
        var iframe = document.createElement('iframe');
        iframe.src = this.options.smscnt
        iframe.style = "display:none;border:none;background:none;height:0;width:0;";
        document.body.appendChild(iframe);
        setTimeout(() => {
            try {
                document.body.removeChild(iframe);
            } catch(e) {}
        }, 800);
      }
    }
  }
}
</script>

<style lang="scss">
@import '../scss/_smsup';
</style>



// WEBPACK FOOTER //
// SmsUp.vue?74c21faa